import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { LINKEDIN_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const LinkedInIcon = (props: IconGlyphProps) => <Icon {...props} glyph={LINKEDIN_GLYPH} />;
